import React, { useEffect } from 'react'
import i18next from 'i18next'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import EmergencyContact from '../emergencyContact/EmergencyContact'
import ChangePassword from '../password/ChangePassword'
import Profile from './profile/Profile'
import { getAccessTab } from '../../utils/menuHelper';
import * as keyMenu from '../../scripts/KeyMenu';
import { withNamespaces } from 'react-i18next';

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function TabMyFile(props) {
    const [value, setValue] = React.useState(0);
    const [index, setIndex] = React.useState(0);
    const [hasEmergency, setHasEmergency] = React.useState(false);
    const [hasProfile, setHasProfile] = React.useState(false);

    useEffect(() => {
        const access = validateAccessTab();

        activateInitialTab(access);
    }, []);

    const validateAccessTab = () => {
        const isTabEmergency = getAccessTab(keyMenu.TAB_EMERGENCYCONTACTS);
        const isTabProfile = getAccessTab(keyMenu.TAB_PROFILEDET);

        setHasEmergency(isTabEmergency);
        setHasProfile(isTabProfile);

        const access = { isTabEmergency, isTabProfile };

        return access;
    }

    const activateInitialTab = (access) => {
        if (access.isTabProfile) {
            setIndex(0);
        } else if (access.isTabEmergency) {
            setIndex(1);
        }
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handlePanelProfileClick = () => {
        setIndex(0);
    }

    const handlePanelEmergencyClick = () => {
        setIndex(1);
    }

    return (
        <React.Fragment>
            <div className={"rootMyFile"}>
                <AppBar position="static" color="default">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="scrollable"
                        indicatorColor="primary"
                        scrollButtons="on"
                        textColor="primary"
                        className={"TabPage"}
                    >
                        {hasProfile && <Tab className={"TabPageButton"} label={i18next.t("myFile:tabPanel.profile")} {...a11yProps(0)} onClick={handlePanelProfileClick} />}
                        {hasEmergency && <Tab className={"TabPageButton"} label={i18next.t("myFile:tabPanel.emergencyContact")} {...a11yProps(1)} onClick={handlePanelEmergencyClick} />}
                    </Tabs>
                </AppBar>

                {hasProfile && index == 0 && <Profile />}
                {hasEmergency && index == 1 && <EmergencyContact />}
            </div>
        </React.Fragment>
    );
}

export default withNamespaces(['myFile'], { wait: true })(TabMyFile);